import { initializeApp } from 'firebase/app';


export const firebaseConfig = {
    apiKey: "AIzaSyBtNPSIfMSxXnjH_Iw95axe2hlcgl42hsg",
    authDomain: "stackframe-e0d0e.firebaseapp.com",
    projectId: "stackframe-e0d0e",
    storageBucket: "stackframe-e0d0e.appspot.com",
    messagingSenderId: "493577008261",
    appId: "1:493577008261:web:20cd77a4a444f3ee7765ec",
    measurementId: "G-RGQ8FV59K3"
  };

  export const app = initializeApp(firebaseConfig);
